import { render, staticRenderFns } from "./SendSettingsStep.vue?vue&type=template&id=3b3eae3e&scoped=true"
import script from "./SendSettingsStep.vue?vue&type=script&lang=ts"
export * from "./SendSettingsStep.vue?vue&type=script&lang=ts"
import style0 from "./SendSettingsStep.vue?vue&type=style&index=0&id=3b3eae3e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3eae3e",
  null
  
)

export default component.exports